// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: 'AIzaSyBh4V-jJ6-F5yhR4r_JoOCp0_6xZbnhpbY',
    authDomain: 'reportes-pinos.firebaseapp.com',
    projectId: 'reportes-pinos',
    storageBucket: 'reportes-pinos.appspot.com',
    messagingSenderId: '572534778690',
    appId: '1:572534778690:web:875f5a1b239cf57f97b6db',
    measurementId: 'G-2SRNXZ5TJX'
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
